import React, { useMemo, useState } from "react";


function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}
function endOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0);
}
function ymd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}
function addMonths(d, n) {
  return new Date(d.getFullYear(), d.getMonth() + n, 1);
}
function clamp(n, a, b) {
  return Math.max(a, Math.min(b, n));
}

// 0 = Po ... 6 = Ne
function weekdayMon0(dateObj) {
  const js = dateObj.getDay(); // 0=Ne..6=So
  return (js + 6) % 7;
}

function CalendarPopover({
  open,
  onClose,
  selectedDay,
  onPickDay,
  dayCountMap,
  rangeFromIso, // optional ISO
  rangeToIso,   // optional ISO
}) {
  const [viewMonth, setViewMonth] = useState(() => {
    // default: month of selectedDay or today
    if (selectedDay) return new Date(selectedDay + "T00:00:00");
    return new Date();
  });

  // keep month in sync when selectedDay changes
  React.useEffect(() => {
    if (!selectedDay) return;
    const d = new Date(selectedDay + "T00:00:00");
    setViewMonth(new Date(d.getFullYear(), d.getMonth(), 1));
  }, [selectedDay]);

  if (!open) return null;

  const monthStart = startOfMonth(viewMonth);
  const monthEnd = endOfMonth(viewMonth);

  const from = rangeFromIso ? new Date(rangeFromIso) : null;
  const to = rangeToIso ? new Date(rangeToIso) : null;

  const leading = weekdayMon0(monthStart); // kolik prázdných buněk před 1.
  const totalDays = monthEnd.getDate();

  // build 6x7 = 42 cells
  const cells = [];
  for (let i = 0; i < 42; i++) {
    const dayNum = i - leading + 1;
    if (dayNum < 1 || dayNum > totalDays) {
      cells.push(null);
    } else {
      const d = new Date(viewMonth.getFullYear(), viewMonth.getMonth(), dayNum);
      cells.push(d);
    }
  }

  const monthLabel = viewMonth.toLocaleDateString("cs-CZ", { month: "long", year: "numeric" });

  return (
    <div className="snap-cal-popover-backdrop" onMouseDown={onClose}>
      <div className="snap-cal-popover" onMouseDown={(e) => e.stopPropagation()}>
        <div className="snap-cal-head">
          <button type="button" className="snap-cal-nav" onClick={() => setViewMonth(addMonths(viewMonth, -1))}>‹</button>
          <div className="snap-cal-title">{monthLabel}</div>
          <button type="button" className="snap-cal-nav" onClick={() => setViewMonth(addMonths(viewMonth, +1))}>›</button>
        </div>

        <div className="snap-cal-weekdays">
          {["Po","Út","St","Čt","Pá","So","Ne"].map((w) => (
            <div key={w} className="snap-cal-wd">{w}</div>
          ))}
        </div>

        <div className="snap-cal-grid">
          {cells.map((d, idx) => {
            if (!d) return <div key={idx} className="snap-cal-cell is-empty" />;

            const key = ymd(d);
            const count = dayCountMap?.get(key) || 0;
            const isSelected = selectedDay === key;

            // optional range disable
            let disabled = false;
            if (from && d < new Date(from.getFullYear(), from.getMonth(), from.getDate())) disabled = true;
            if (to && d > new Date(to.getFullYear(), to.getMonth(), to.getDate())) disabled = true;

            const intensity = clamp(count, 0, 12); // jen pro class

            return (
              <button
                key={idx}
                type="button"
                className={[
                  "snap-cal-cell",
                  isSelected ? "is-selected" : "",
                  disabled ? "is-disabled" : "",
                  count > 0 ? "has-changes" : "",
                  count > 0 ? `i${Math.min(4, Math.ceil(intensity / 3))}` : "",
                ].join(" ")}
                onClick={() => {
                  if (disabled) return;
                  onPickDay?.(key);
                  onClose?.(); // po picku zavřít kalendář
                }}
                title={count > 0 ? `${count} změn` : "bez změn"}
              >
                <span className="snap-cal-daynum">{d.getDate()}</span>
               {/* {count > 0 && <span className="snap-cal-dot" />} */}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}


export default CalendarPopover;
